import "#legacy/admin/assessment_builder/_generated_templates.js";
import "#legacy/admin/assessment_builder/views/base.js";
import "#legacy/admin/assessment_builder/views/mixins/thumbnail_editor.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.ResponseFormChoice = class ResponseFormChoice extends (
  AssessmentBuilder.Views.Mixins.ThumbnailEditor(AssessmentBuilder.Views.Base)
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    this.nextQuestionView = new AssessmentBuilder.Views.ResponseFormNextQuestionSelect({
      model: this.model,
      selectItems: this.selectItems,
    }).render();

    // BEHAVIOUR
    return this.listenTo(this.model, "change", this.render);
  }

  render() {
    this.$el.html(this.template(this.selectTemplateContext(this.model.attributes, { pointsItems: "points" })));

    super.render();

    this.$("attribute.next_question").html(this.nextQuestionView.el);
    return this;
  }

  triggerDeleteResponseClicked() {
    return this.$el.trigger(AssessmentBuilder.Events.Response.removeClicked, [this.model]);
  }
};
AssessmentBuilder.Views.ResponseFormChoice.prototype.tagName = "response-form-choice";
AssessmentBuilder.Views.ResponseFormChoice.prototype.className = "response-form-choice";
AssessmentBuilder.Views.ResponseFormChoice.prototype.template = _.template(
  AssessmentBuilder.Templates.Response.Form.choice,
);
AssessmentBuilder.Views.ResponseFormChoice.prototype.editorTriggerElementSelector =
  '[data-assessment-builder-behaviour~="response-thumbnail-editor"]';

AssessmentBuilder.Views.ResponseFormChoice.prototype.events = {
  "change :input, sp-select": "handleAttributeChange",
  "click remove-response-button": "triggerDeleteResponseClicked",
};
